var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-error-page"},[_c('h1',[_vm._v("Não foi possível conectar a API "+_vm._s(_vm.apiURL))])])
}
var staticRenderFns = []

export { render, staticRenderFns }